module.exports = __webpack_public_path__ + "static/Nine-2dc307947e14e3ea3229ae05b3c185dd.png";